import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  BookingEmailTemplateFormData,
  BookingEmailTemplateFormResponse,
  CreateBookingEmailTemplatesResponse,
  SendTestEmailData,
  SendTestEmailResponse,
} from '@/types/api/mutations';

import { BOOKING_EMAIL_TEMPLATES_LIST_QUERY_KEY } from '@/queries';

import { HttpClient } from '@/network/HttpClient';

export const useCreateBookingEmailTemplatesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (url: string) =>
      HttpClient.request<CreateBookingEmailTemplatesResponse>({
        method: 'POST',
        url,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [BOOKING_EMAIL_TEMPLATES_LIST_QUERY_KEY],
      });
    },
  });
};

export const useSendTestEmailMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: SendTestEmailData }) =>
      HttpClient.request<SendTestEmailResponse>({
        method: 'POST',
        url: params.url,
        data: params.data,
      }),
  });

export const useBookingEmailTemplateFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: BookingEmailTemplateFormData;
    }) =>
      HttpClient.request<BookingEmailTemplateFormResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
      }),
  });
